// saga.ts
import { call, put, takeEvery } from 'redux-saga/effects';
import { createLandmark, deleteLandmark, getLandmarkApi, updateLandmark } from '../../api/LandmarkApi'; // Adjust the path as needed
import {
    getLandmarkSuccess,
    getLandmarkFailure,
    createLandmarkSuccess,
    createLandmarkFailure,
    updateLandmarkSuccess,
    updateLandmarkFailure,
    deleteLandmarkSuccess,
    deleteLandmarkFailure,
} from './actions';

// Saga to handle fetching Landmarks
function* fetchLandmarkSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(getLandmarkApi, action.payload);
        yield put(getLandmarkSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(getLandmarkFailure(errorMessage));
    }
}

// // Saga to handle creating a Landmark
function* createLandmarkSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(createLandmark, action.payload);
        yield put(createLandmarkSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(createLandmarkFailure(errorMessage));
    }
}

// // Saga to handle updating a Landmark
function* updateLandmarkSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(updateLandmark, action.payload.data, action.payload.id);
        yield put(updateLandmarkSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(updateLandmarkFailure(errorMessage));
    }
}

// // Saga to handle updating a Landmark
function* deleteLandmarkSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(deleteLandmark, action.payload.id);
        yield put(deleteLandmarkSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';
        yield put(deleteLandmarkFailure(errorMessage));
    }
}

export default function* LandmarkSaga() {
    yield takeEvery('GET_LANDMARK_REQUEST', fetchLandmarkSaga);
    yield takeEvery('GET_LANDMARK_AREAID_REQUEST', fetchLandmarkSaga);
    yield takeEvery('CREATE_LANDMARK_REQUEST', createLandmarkSaga);
    yield takeEvery('UPDATE_LANDMARK_REQUEST', updateLandmarkSaga);
    yield takeEvery('DELETE_LANDMARK_REQUEST', deleteLandmarkSaga);
}
